export default __webpack_public_path__ + "static/media/plan-icon.8eb31610.svg";